import { Component, Input, OnDestroy } from '@angular/core';
import { BaseComponentContext, Deferred } from '../../../../modules/tcm-core.module';
import { BroadCastEvents } from '../../../../common/broad-cast-events.enum';
import { PatientAlertShowUpModel } from '../../../../models/patients';
import { PatientAlertDataService } from '../../../../services/patient-alert-data.service';
import { PermissionsService } from '../../../../services';
import { permissionAreaKeyNameOf, permissionEnityKeyNameOf } from '../../../../helpers/permission.helpers';
import { PatientArea } from '../../../../models/roles';

@Component({
    selector: 'patient-alert-show-up',
    templateUrl: './patient-alert-show-up.component.html',
    styleUrls: ['./patient-alert-show-up.component.scss'],
    standalone: false
})
export class PatientAlertShowUpComponent implements OnDestroy {
    @Input() public alerts: PatientAlertShowUpModel[];
    private _cancellationTokenDeferred: Deferred;
    public canEdit: boolean;

    public constructor(private componentContext: BaseComponentContext, 
        private patientAlertDataService: PatientAlertDataService, 
        private permissionsService: PermissionsService) {
        this._cancellationTokenDeferred = new Deferred();
        
        this.permissionsService.getEntityPermissions$(permissionAreaKeyNameOf('patients'), permissionEnityKeyNameOf<PatientArea>('patients'))
            .subscribe(x => {
                this.canEdit = x && x.canEdit
            });
    }

    public async complete(id: number) {
        await this.completeAlerts([id]);

        this.alerts.splice(this.alerts.findIndex(x => x.id == id), 1);

        if (!this.alerts.length) {
            this.goBack();
        }
    }

    public async completeAll() {
        await this.completeAlerts(this.alerts.map(x => x.id));

        this.goBack();
    }

    public readonly goBack = (data?: any) => {
        this.componentContext.navService.navigateBack(data);
    };

    ngOnDestroy() {
        this._cancellationTokenDeferred.resolve();
    }

    async completeAlerts(alerts: number[]) {
        await this.patientAlertDataService.completeAlerts(alerts, this._cancellationTokenDeferred.promise());

        this.componentContext.broadcastService.next({ name: BroadCastEvents.PatientAlertChanged });
    }
}
